import * as moment from 'moment';

angular.module('nv.support-attendance-form').component('studentAttendanceItem', {
  template: `
      <div class="item" layout="row" layout-align="start center">
        <div>{{ctrl.record.student.lastFirst}} (started on {{ctrl.formattedStartsOn()}})</div>
        <div flex></div>
        <div>
          <md-radio-group
              layout="row"
              layout-xs="column"
              class="md-secondary"
              layout-padding
              ng-model="ctrl.record.status"
              ng-change="ctrl.markAsChanged(ctrl.record)">
            <md-radio-button aria-label='mark as PRESENT' value="PRESENT">Present</md-radio-button>
            <md-radio-button aria-label='mark as LATE' value="ABSENT">Absent</md-radio-button>
            <md-radio-button aria-label='mark as ABSENT' value="LATE">Late</md-radio-button>
          </md-radio-group>
        </div>
      </div>
    `,
  bindings: {
    record: '=',
  },
  controller: function StudentAttendanceItemCtrl() {
    /**
     * Tag a record with hasChanged via ng-change
     */
    this.formattedStartsOn = function() {
      return moment(this.record.startsOn).format('ll');
    };

    this.markAsChanged = function(record) {
      record.hasChanged = true;
    };
  },
  controllerAs: 'ctrl',
});
